import { defineStore } from 'pinia';
import { getListPayCalendar } from '@apps-payroll/modules/pay-calendar/requests/webapp/get-list-pay-calendar';
import { PayCalendar } from '@apps-payroll/modules/pay-calendar/types';

export const usePayCalendarStore = defineStore('people/pay-calendar', {
  state: () => ({
    payCalendarsIndexed: {} as Record<number, PayCalendar>,
  }),
  actions: {
    async fetchPayCalendars(): Promise<void> {
      try {
        const payCalendars = await getListPayCalendar();
        this.payCalendarsIndexed = payCalendars.reduce(
          (reduced: Record<number, PayCalendar>, calendar) => {
            reduced[calendar.id] = calendar;
            return reduced;
          },
          {}
        );
      } catch (e) {
        console.error(e);
      }
    },
    getPayCalendarById(id: number): PayCalendar | undefined {
      return this.payCalendarsIndexed[id];
    },
  },
});
